module.exports = __webpack_public_path__ + "static/media/ch-logo.8cf61a74.svg";